import * as actions from 'actions';

const INITIAL_STATE = [];

const itemForChatMessageId = (id) => ({chatMessageId: id});
const itemForChatDocumentId = (id) => ({chatDocumentId: id});
const itemForChatWebsiteId = (id) => ({chatWebsiteId: id});
const itemForGoalsIds = (ids) => ({goalsIds: ids});
const itemForChatQuestionnaireId = (id) => ({chatQuestionnaireId: id});
const itemsForChatEntities = (ids, wrapper) => ids.map(id => wrapper(id));

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.CHAT_MESSAGES_UPDATE:
      return [
        ...state,
        ...itemsForChatEntities(action.result.chatMessagesIds, itemForChatMessageId)
      ];

    case actions.CHAT_DOCUMENTS_RECEIVED:
      return [
        ...state,
        ...itemsForChatEntities(action.result.chatDocumentsIds, itemForChatDocumentId)
      ];

    case actions.CHAT_WEBSITES_RECEIVED:
      return [
        ...state,
        ...itemsForChatEntities(action.result.chatWebsitesIds, itemForChatWebsiteId)
      ];

    case actions.GOALS_RECEIVED: {
      const itemsWithoutGoals = state.filter(item => !item.goalsIds);

      return [
        ...itemsWithoutGoals,
        itemForGoalsIds(action.result.goalsIds)
      ];
    }

    case actions.CHAT_QUESTIONNAIRES_RECEIVED: {
      const questionnaireId = action.result.chatQuestionnairesIds;

      if(questionnaireId === 'eos') {
        return state;
      }

      const itemsWithoutWithThisQuestionnaire = state.filter(item => !item.chatQuestionnaireId || item.chatQuestionnaireId !== questionnaireId);

      return [
        ...itemsWithoutWithThisQuestionnaire,
        itemForChatQuestionnaireId(questionnaireId)
      ];
    }

    case actions.CHAT_STATE_UPDATE: {
      if(!action.chatStateOnServer.activeChat) {
        return INITIAL_STATE;
      }

      return state;
    }

    case actions.CHAT_MESSAGE_REMOVE:
      return state.filter(item => item.chatMessageId && item.chatMessageId !== action.id);

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/chatItems/list/reducer.js
 **/